import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { url: String };
  static targets = [
    "emailInput",
    "submitButton",
    "successMessage",
    "successText",
    "errorMessage",
    "errorText",
  ];

  async submit(event) {
    event.preventDefault();

    var email = this.emailInputTarget.value.trim();
    if (!email) return;

    // Hide previous messages
    this.successMessageTarget.classList.add("hidden");
    this.errorMessageTarget.classList.add("hidden");

    // Show loading state
    this.submitButtonTarget.classList.add("loading", "disabled");

    try {
      var response = await fetch(this.urlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document
            .querySelector('meta[name="csrf-token"]')
            .getAttribute("content"),
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({ email: email }),
      });

      var data = await response.json();

      if (data.success) {
        this.successTextTarget.textContent = data.message;
        this.successMessageTarget.classList.remove("hidden");
        this.emailInputTarget.value = "";
        // team_invite_sent is captured server-side in
        // Welcome::RecommendationsController#invite — the source of truth for a
        // successful invite. Capturing it here too double-counted the event with
        // an inconsistent property name (invitee_email_domain vs the server's
        // invited_email_domain), so the client only reports failures.
      } else {
        this.errorTextTarget.textContent = data.error;
        this.errorMessageTarget.classList.remove("hidden");
        this.capture("team_invite_failed", { error: data.error });
      }
    } catch (_error) {
      this.errorTextTarget.textContent =
        "Something went wrong. Please try again.";
      this.errorMessageTarget.classList.remove("hidden");
      this.capture("team_invite_failed", { error: "network_error" });
    } finally {
      this.submitButtonTarget.classList.remove("loading", "disabled");
    }
  }

  capture(eventName, props = {}) {
    if (typeof window.posthog === "undefined") return;
    window.posthog.capture(eventName, {
      surface: "welcome_recommendations",
      ...props,
    });
  }
}
